import React, { FC } from 'react'
import { StyledDashboard, Overview, Earnings, Payouts } from '.'

const Dashboard: FC = () => {
  return (
    <StyledDashboard>
      <Overview />
      <hr />
      <Earnings />
      <hr />
      <Payouts />
    </StyledDashboard>
  )
}

export default Dashboard
